import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function getTextFile(noteID: string): Promise<string | null> {
    if (!noteID) return null;

    try {
        const { data: { user } } = await supabase.auth.getUser();

        if (!user) {
            console.error("No authenticated user found");
            return null;
        }

        const userId = user.id;
        const bucket = supabase.storage.from("user-data");
        const folderName = userId;
        
        if (!folderName) {
            throw new Error("Folder name not found");
        }

        const { data, error } = await bucket.createSignedUrl(
            `${folderName}/${noteID}`,
            60
        );

        if (error) {
            // If the object doesn't exist, that's okay - just return null
            if (error.message === "Object not found") {
                return null;
            }
            throw error;
        }

        if (!data?.signedUrl) {
            return null;
        }

        // Fetch the actual file content using the signed URL
        const response = await fetch(data.signedUrl);
        
        if (!response.ok) {
            // If the file doesn't exist, return null
            if (response.status === 404) {
                return null;
            }
            throw new Error(`Failed to fetch file: ${response.statusText}`);
        }

        const text = await response.text();

        return text;
    } catch (error) {
        console.error("Error fetching text file:", error);
        // Don't show toast for "object not found" errors - that's expected behavior
        if (error && typeof error === 'object' && 'message' in error && 
            (error.message as string).includes("Object not found")) {
            return null;
        }
        toast.error("Failed to fetch text file");
        return null;
    }
}
